import { colors } from "../constants/colors";

export const disableStyleButtonMui = {
    color: colors.lampang_disable_gray
}